export default function DpiaOutline() {
  return (
    <div style={{ padding: "1.5rem", maxWidth: "900px" }}>
      <h1>DPIA Outline - Pilot (Draft)</h1>

      <h2>Plain language summary</h2>
      <p>
        This is a short risk review for the pilot. It identifies risks, mitigations, and open
        questions before wider rollout.
      </p>

      <h2>1. Project description</h2>
      <p>
        Pilot of a classroom management app that stores seating plans, behaviour events, learning
        objectives, and attendance to support teaching and analytics.
      </p>

      <h2>2. Necessity and proportionality</h2>
      <ul>
        <li>Data is limited to what is required for pilot features</li>
        <li>Access is restricted to authenticated users</li>
        <li>SEN status/detail may be collected where provided to support teaching and learning</li>
        <li>
          Processing of special category data relies on an appropriate condition under data
          protection law as set out in the trust policy (for example, substantial public interest
          in education, vital interests, or other applicable conditions)
        </li>
      </ul>

      <h2>3. Risk assessment (initial)</h2>
      <ul>
        <li>
          Risk: unauthorized access to student data
          <br />
          Mitigation: Firebase auth + rules; admin role checks
        </li>
        <li>
          Risk: excessive data retention
          <br />
          Mitigation: retention policy; plan for cleanup at end of pilot
        </li>
        <li>
          Risk: data accuracy issues
          <br />
          Mitigation: teacher control of class data; audit trail via timestamps
        </li>
        <li>
          Risk: third-party exposure (cloud providers)
          <br />
          Mitigation: list processors; verify regions and contracts
        </li>
      </ul>

      <h2>4. Residual risk</h2>
      <p>
        Medium: pilot data is still personal data; require review by school DPO.
      </p>

      <h2>5. Consultation</h2>
      <p>School DPO or data protection lead to review pilot scope.</p>
      <p>Contact: Gregory Hamilton (Ghamilton@netherthorpe-mlt.co.uk)</p>

      <h2>6. Decision</h2>
      <p>Proceed with pilot after DPO review and sign-off.</p>

      <h2>7. Action items</h2>
      <ul>
        <li>Document lawful basis per trust policy and confirm data controller details (Netherthorpe School)</li>
        <li>Confirm hosting regions (Firebase: europe-west2)</li>
        <li>Confirm deletion plan and retention enforcement</li>
        <li>Confirm data request response time (within 30 days unless extended under policy)</li>
        <li>Confirm SAR Log is in place to track requests and deadlines</li>
      </ul>

      <p style={{ marginTop: "1.5rem", fontStyle: "italic" }}>
        Disclaimer: This draft is not legal advice and should be reviewed by the school's data
        protection lead.
      </p>
    </div>
  );
}
